import Vue from "vue";

class dbflex {
  constructor(logic = "$and") {
    this._logic = logic;
    this._filters = [];
  }

  eq(field, value) {
    if (!field) return;
    if (typeof value == "string") {
      let endWith = value.startsWith("*"),
        startWith = value.endsWith("*");

      value = value.replace(/\*/g, "");
      if (startWith && endWith) {
        this.contain(field, value);
        return;
      } else if (startWith) {
        this.startWith(field, value);
        return;
      } else if (endWith) {
        this.endWith(field, value);
        return;
      }
    }

    this._filters.push({
      Field: field,
      Operator: "$eq",
      Value: value,
    });
  }

  contain(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$contains",
      Value: value,
    });
  }

  startWith(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$startwith",
      Value: value,
    });
  }

  endWith(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$endwith",
      Value: value,
    });
  }

  lt(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$lt",
      Value: value,
    });
  }

  lte(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$lte",
      Value: value,
    });
  }

  gt(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$gt",
      Value: value,
    });
  }

  gte(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$gte",
      Value: value,
    });
  }

  ne(field, value) {
    if (!field) return;
    this._filters.push({
      Field: field,
      Operator: "$ne",
      Value: value,
    });
  }

  in(field, value) {
    if (!field) return;
    if (!Array.isArray(value)) value = [value];
    this._filters.push({
      Field: field,
      Operator: "$in",
      Value: value,
    });
  }

  nin(field, value) {
    if (!field) return;
    if (!Array.isArray(value)) value = [value];
    this._filters.push({
      Field: field,
      Operator: "$nin",
      Value: value,
    });
  }

  add(filters) {
    if (!filters || filters.length == 0) return;
    this._filters.push(filters);
  }

  get() {
    if (!this._filters || this._filters.length == 0) return null;

    return {
      Logic: this._logic,
      Filters: this._filters,
    };
  }
}
Vue.prototype.$dbflex = dbflex;
export default dbflex;